<template>
  <component :is="componentToRender"></component>
</template>

<script>
import { mapGetters } from 'vuex';
import DownloadApk from './download-apk.vue';
import DownloadApkMobile from './download-apk-mobile.vue';

export default {
  name: 'DownloadApkWrapper',
  components: {
    DownloadApk,
    DownloadApkMobile
  },
  computed: {
    ...mapGetters(['deviceType']),
    componentToRender () {
      return this.deviceType === 'mobile' ? 'DownloadApkMobile' : 'DownloadApk';
    }
  }
}
</script> 